import React, { Component } from 'react';
import { EDITOR_MOBILE_PROPERTIES_MENU_ID } from 'crazyEditor/core/constants/editorConstants';
import Radium from 'radium';
import { connect } from 'react-redux';
import { getElementDefinitionProps, isTextElement, isFontSelectable, getElementIcon, getElementName } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { isPageElement } from 'crazyEditor/core/elements/utils/elementStaticUtils';
import styles from './PropertiesMenuStyles';
import { FontProperty } from './properties/index';
import { getSelectedElements, getPageElement, isMultiSelect } from 'crazyEditor/redux/modules/element/elementSelectors';
import { CustomSvgIcon } from 'crazyEditor/components/EditorUI/BaseUI/index';
import * as Colors from 'material-ui/styles/colors';

@connect(
  state => ({
    selectedElements: getSelectedElements(state),
    selectedElementIds: state.stage.selectedElementIds,
    isMultiSelect: isMultiSelect(state),
  })
)
@Radium
export default class MobilePropertiesMenu extends Component {
  render() {
    const { selectedElementIds, selectedElements, isMultiSelect } = this.props;
    if (!selectedElementIds.length || isMultiSelect) {
      return null;
    }
    let elementType = null;
    let selectedElement;
    if (selectedElements.length) {
      selectedElement = selectedElements[0];
      elementType = selectedElement.type;
    }
    return (
      <div id={EDITOR_MOBILE_PROPERTIES_MENU_ID}>
        <div style={styles.container}>
          <div style={styles.elementTypeContainer}>
            <CustomSvgIcon path={getElementIcon(selectedElement)} width="48px" height="48px" color={Colors.grey400}/>
            <div style={styles.elementTypeLabel}>{getElementName(elementType)}</div>
            <span style={styles.elementTypeArrow} />
          </div>
          { isFontSelectable(selectedElements[0]) &&
          <FontProperty
            first
            isMobileView
            selectedElementIds={selectedElementIds}
            selectedElements={selectedElements}
          />
          }
        </div>
      </div>
    );
  }
}
